export default {
    root: {
        class: [
            // Layout & Alignment
            'tw-flex tw-items-center tw-justify-center',
            'tw-min-w-10',
            // Typography
            'tw-text-sm tw-text-gray-900 dark:tw-text-gray-100',
            // Borders & Spacing
            'tw-border-y tw-border-r-0 tw-border-gray-300 dark:tw-border-zinc-500',
            'tw-px-4',
            // Rounded corners
            'first:tw-rounded-l-md last:tw-rounded-r-md',
            // Borders
            'first:tw-border-l last:tw-border-r',
        ],
    },
};
